import { API_ENDPOINT } from './config';

export const urlsFriJobs = {
  friJobsJobs: `${API_ENDPOINT}/fri-jobs/jobs`,
  friJobsPublicJobs: `${API_ENDPOINT}/fri-jobs/jobs/public`,
  friJobsTypes: `${API_ENDPOINT}/fri-jobs/job-types`,
  friJobsInterested: (id) => `${API_ENDPOINT}/fri-jobs/jobs/interested/${id}`,
  friJobsJobDetail: (id) => `${API_ENDPOINT}/fri-jobs/jobs/${id}`,
  friJobsPublicJobDetail: (id) => `${API_ENDPOINT}/fri-jobs/jobs/public/${id}`,
  friJobsJobApprove: (id) => `${API_ENDPOINT}/fri-jobs/jobs/approve/${id}`,
  friJobsJobDisapprove: (id) =>
    `${API_ENDPOINT}/fri-jobs/jobs/disapprove/${id}`,
  friJobsJobsArchive: (id) => `${API_ENDPOINT}/fri-jobs/jobs/archive/${id}`,
  friJobsJobsDelete: (id) => `${API_ENDPOINT}/fri-jobs/jobs/${id}`,
  friJobsClickStats: `${API_ENDPOINT}/fri-jobs/click-statistics`,
  friJobsInterests: `${API_ENDPOINT}/fri-jobs/interests`,
  friJobsMyInterests: `${API_ENDPOINT}/fri-jobs/interests`,
  friJobsInterestEdit: (id) => `${API_ENDPOINT}/fri-jobs/interests/${id}`,
  friJobsInterestsDetail: (id) => `${API_ENDPOINT}/fri-jobs/interests/${id}`,
  friJobsInterestsDelete: (id) => `${API_ENDPOINT}/fri-jobs/interests/${id}`,
  friJobsInterestCv: (id) => `${API_ENDPOINT}/fri-jobs/interest/cv/${id}`,
  friJobsInterestMotivationLetter: (id) =>
    `${API_ENDPOINT}/fri-jobs/interest/motivation-letter/${id}`,
};

export const routesFriJobs = {
  // Public
  friJobsHome: '/fri-jobs',
  friJobsList: '/pracovne-ponuky',
  friJobsDetail: '/pracovna-ponuka',

  // CMS
  cmsFriJobsJobs: '/cms/fri-jobs/jobs',
  cmsFriJobsMyPartnerDetails: '/cms/fri-jobs/my-details',
  cmsFriJobsMyJobs: '/cms/fri-jobs/my-jobs',
  cmsFriJobsJobsForApproval: '/cms/fri-jobs/jobs-for-approval',
  cmsFriJobsJobsDisapproved: '/cms/fri-jobs/jobs-disapproved',
  cmsFriJobsMyInterests: '/cms/fri-jobs/my-interests',
  cmsFriJobsInterestEdit: '/cms/fri-jobs/interest/edit',
  cmsFriJobsInterestCreate: '/cms/fri-jobs/interest/create',
  cmsFriJobsInterestDetail: '/cms/fri-jobs/interest/detail',
  cmsFriJobsArchive: '/cms/fri-jobs/archive',
  cmsFriJobsJobDetail: '/cms/fri-jobs/detail',
  cmsFriJobsJobInterested: '/cms/fri-jobs/interested',
  cmsFriJobsJobCreate: '/cms/fri-jobs/create',
  cmsFriJobsJobEdit: '/cms/fri-jobs/edit',
};
